import { useEffect, useState } from 'react'

import VideoPlayer from 'features/VideoPlayer/VideoPlayer'

import styles from './StreamArchiveVideoModal.module.scss'

import { useHeaderLayout } from 'context/headerLayoutContext'
interface StreamArchiveVideoModalProps {
  videoUrl: string
  poster?: string
  title?: string
  onClose: () => void
}

const StreamArchiveVideoModal = ({
  videoUrl,
  poster,
  title,
  onClose
}: StreamArchiveVideoModalProps) => {
  const [showControls, setShowControls] = useState(true)
      const { setHideFooter } = useHeaderLayout()

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowControls(false)
    }, 2500)

    return () => clearTimeout(timeout)
  }, [])
    useEffect(() => {
        setHideFooter(true)
        return () => {
            setHideFooter(false)
        }
    }, [setHideFooter])
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [onClose])

  useEffect(() => {
    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [])

  const toggleControls = () => {
    setShowControls((prev) => !prev)
  }

  const handleOverlayClick = () => {
    onClose()
  }

  const handleContentClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
  }

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.content} onClick={handleContentClick}>
        <button
          type='button'
          className={styles.closeButton}
          onClick={onClose}
          aria-label='Close stream archive'
        >
          ×
        </button>

        {title ? <div className={styles.title}>{title}</div> : null}

        <div className={styles.playerWrapper}>
          <VideoPlayer
            url={videoUrl}
            poster={poster}
            minimized={false}
            showControls={showControls}
            setShowControls={setShowControls}
            toggleControls={toggleControls}
            isActive={true}
            controlsDisabled={false}
          />
        </div>
      </div>
    </div>
  )
}

export default StreamArchiveVideoModal